import className from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class AccordiItemBody extends Component {

  constructor(props) {

    super(props);

    this.state = {
      style: {
        maxHeight: this.props.maxHeight,
        overflow: this.props.overflow,
        transition: 'max-height ' + this.props.transitionSpeed + 'ms ease'
      }
    }
  }

  componentDidMount() {
    this.removeMaxHeight();
  }

  componentWillReceiveProps(props) {
    this.removeMaxHeight(props);
  }

  componentWillUnmount() {
    if (this.maxHeightTimeout) {
      clearTimeout(this.maxHeightTimeout)
    }
  }

  /*
  * we need to update the style after the transition has finished to REMOVE the maxheight
  */
  removeMaxHeight(props) {

    props = props || this.props;

    if (this.maxHeightTimeout) {
      clearTimeout(this.maxHeightTimeout)
    }

    this.maxHeightTimeout = setTimeout(() => {
      //console.log('setting max-height to none');
      this.setState({
        style: {
          maxHeight: 'none',
          overflow: props.overflow,
          transition: 'max-height ' + props.transitionSpeed + 'ms ease'
        }
      });
    }, props.transitionSpeed);
  }

  render() {

    return (
      <div aria-labelledby={`accorditabs-item-title-${this.props.id}`}
        className={className('c-accorditabs__content', this.props.className)}
        id={`accorditabs-item-body-${this.props.id}`}
        style={this.state.style}>
        <div className="accorditabs-item-body-wrapper">
          {this.props.children}
        </div>
      </div>
    );
  }

}

AccordiItemBody.propTypes = {
  className: PropTypes.string,
  maxHeight: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
  ]),
  overflow: PropTypes.string,
  id: PropTypes.string.isRequired
};

AccordiItemBody.defaultProps = {
    transitionSpeed: 300
};



// WEBPACK FOOTER //
// ./webapp/components/elements/AccordiTab/AccordiItemBody.js